import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    txjymShow: false, //防pa校验
    RWLCType: '',
    // 要缓存的数据
    curid: 0,
    nva: [],
    identityType: '',
    token: '',
    // 功能编码
    functions: [],
    frameDisplay: true, // 边框显示,
    signSource: 'init' // 数据来源
  },
  mutations: {
    EditType(state, type) {
      state.RWLCType = type
    },
    setcurid(state, index) {
      state.curid = index
    },
    setnav(state, data) {
      state.nva = data
    },
    setToken(state, data) {
      state.token = data
    },
    SET_DATA: (state, data) => {
      state.functions = data.functions
      state.identityType = data.identityType
    },
    setFrameDisplay: (state, data) => {
      state.frameDisplay = data
    },
    serSignSource: (state, data) => {
      state.signSource = data
    }
  },
  action: { // 管理mutations
    // SETNAV({commit},data){
    //     commit('SETNAV',data)
    // }
  },
  getters: {
    result: (state) => (id) => {
      if (state.identityType === 'SUPER_ADMIN') {
        return true
      } else {
        return state.functions.includes(id)
      }
    }
  },
  modules: {

  }
})
